(function (global) {
  'use strict';
  var doc = global.document;
  function el(tag, cls, text) {
    var n = doc.createElement(tag); n.className = cls || '';
    if (text != null) n.textContent = text;
    return n;
  }
  function icon(key) {
    var ns = 'http://www.w3.org/2000/svg', n = doc.createElementNS(ns, 'svg'), p = doc.createElementNS(ns, 'path');
    n.setAttribute('viewBox', '0 0 24 24'); n.setAttribute('aria-hidden', 'true');
    n.setAttribute('fill', 'none'); n.setAttribute('stroke', 'currentColor'); n.setAttribute('stroke-width', '2');
    p.setAttribute('d', {
      discount: 'M20 13 11 22 2 13V2h11l9 9-2 2M7 7h.01',
      shipping: 'M1 3h14v13H1zM15 8h4l4 4v4h-8M7 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0M21 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0',
      gift: 'M3 8h18v4H3zM5 12v9h14v-9M12 8v13M12 8C2 8 5 0 9 3c2 1 3 5 3 5Zm0 0c10 0 7-8 3-5-2 1-3 5-3 5Z'
    }[key]); n.appendChild(p); return n;
  }
  function prepare(root) {
    root.classList.remove('clp-checkout--circle');
    root.classList.add('clp-checkout--vertical');
    if (root.querySelector('[data-checkout-timeline]')) return;
    function part(n) { return n && (n.closest('.clp-checkout-part') || n); }
    var list = root.querySelector('[data-checkout-products]');
    var rewards = root.querySelector('[data-checkout-rewards]');
    var oldBag = root.querySelector('[data-checkout-bag]');
    var bag = el('div', 'clv-bag'); bag.setAttribute('data-checkout-bag', '');
    var heading = el('div', 'clv-heading'), title = el('div', 'clv-title', 'My Bag');
    var savings = root.querySelector('[data-checkout-savings]');
    if (savings) { title.appendChild(savings); savings.classList.add('clv-savings'); }
    heading.appendChild(title);
    var total = el('strong', 'clv-total'); total.setAttribute('data-clv-total', '');
    heading.appendChild(total); bag.appendChild(heading);
    var timeline = el('ol', 'clv-timeline');
    timeline.setAttribute('data-checkout-timeline', ''); timeline.setAttribute('aria-label', 'My Bag and rewards');
    timeline.setAttribute('aria-live', 'polite'); bag.appendChild(timeline);
    var target = oldBag || part(list) || part(rewards);
    if (target) target.before(bag); else root.appendChild(bag);
    // Keep the legacy hooks for controller updates and removal handling, but never display them.
    if (!list) { list = el('ul', ''); list.setAttribute('data-checkout-products', ''); bag.appendChild(list); }
    root.querySelectorAll('[data-checkout-products], [data-checkout-rewards], [data-checkout-suggestion]').forEach(function (n) { part(n).hidden = true; });
    var submit = root.querySelector('.clp-checkout__submit');
    if (submit) {
      var action = submit.closest('.clp-checkout-part') || el('div', '');
      action.classList.add('clv-actions');
      if (!action.contains(submit)) action.appendChild(submit);
      bag.after(action);
      var label = submit.querySelector('[data-cl-submit-label]');
      if (label) { label.dataset.clAvailableLabel = 'Add to Cart'; label.textContent = 'Add to Cart'; }
      var price = submit.querySelector('[data-cl-submit-price]'); if (price) price.remove();
    }
    if (oldBag) oldBag.hidden = true;
  }
  function entries(state) {
    var running = 0, rows = [];
    (state.products || []).forEach(function (p) {
      var names = (p.swatches || []).map(function (s) { return s.name; }).filter(Boolean);
      var count = p.splitUnits ? Math.max(1, names.length) : 1;
      var cents = Math.max(0, Math.round(Number(p.cents) || 0));
      for (var i = 0; i < count; i++) {
        var amount = Math.floor(cents / count) + (i < cents % count ? 1 : 0);
        running += amount;
        rows.push({ kind: 'product', value: running, title: p.rowTitle || p.label, detail: p.splitUnits ? names[i] : names.join(', '), cents: amount, gift: p.gift, remove: p.remove });
      }
    });
    state.rewards.forEach(function (r) {
      if (r.key === 'gift' && state.total < state.thresholds.shipping * 100) return;
      rows.push({ kind: 'reward', value: r.unlocked ? Math.min(r.amount * 100, state.total) : r.amount * 100, reward: r });
    });
    if (state.offer && state.offer.price > 0) rows.push({ kind: 'suggestion', value: state.total + state.offer.price });
    var order = { product: 0, suggestion: 1, reward: 2 };
    return rows.sort(function (a, b) { return a.value - b.value || order[a.kind] - order[b.kind]; });
  }
  function render(root, state) {
    var list = root.querySelector('[data-checkout-timeline]');
    if (!list) return;
    root.querySelector('[data-clv-total]').textContent = state.money(state.total);
    list.replaceChildren();
    var rows = entries(state), projected = state.total + (state.offer ? state.offer.price : 0);
    rows.forEach(function (row, i) {
      var next = rows[i + 1], li = el('li', 'clv-row clv-' + row.kind);
      if (next) {
        var preview = state.offer && row.value >= state.total && next.value > state.total && next.value <= projected;
        var line = el('span', 'clv-line' + (preview ? ' is-projected' : next.value <= state.total ? ' is-reached' : ''));
        line.setAttribute('aria-hidden', 'true'); li.appendChild(line);
      }
      var dot = el('span', 'clv-dot'); dot.setAttribute('aria-hidden', 'true');
      li.appendChild(dot);
      if (row.kind === 'reward') {
        var reached = row.reward.unlocked == null ? row.value <= state.total : row.reward.unlocked, label = row.reward.label;
        dot.appendChild(icon(row.reward.key)); dot.classList.add('is-reward');
        if (reached) { dot.classList.add('is-reached'); li.classList.add('is-reached'); }
        var text = label + ' – ' + (reached ? 'Unlocked' : row.reward.pendingText || state.money(Math.max(0, row.value - state.total)) + ' away');
        var reward = el('span', 'clv-reward-label', text); reward.title = text; li.appendChild(reward);
      } else if (row.kind === 'suggestion') {
        var offer = state.offer, button = el('button', 'clv-offer'); button.type = 'button';
        dot.classList.add('is-projected');
        button.appendChild(el('span', 'clv-plus', '+'));
        button.appendChild(el('span', 'clv-offer-title', offer.title + ' · +' + state.money(offer.price)));
        if (offer.original > offer.price) button.appendChild(el('span', 'clv-offer-discount', Math.round((1 - offer.price / offer.original) * 100) + '% off'));
        button.setAttribute('aria-label', 'Add ' + offer.title + '. Potential total ' + state.money(projected));
        button.addEventListener('click', state.add); li.appendChild(button);
      } else {
        var name = el('span', 'clv-product-name');
        name.appendChild(el('strong', '', row.title));
        if (row.detail && row.detail !== row.title) name.appendChild(doc.createTextNode(' – ' + row.detail));
        name.title = row.title + (row.detail ? ' – ' + row.detail : ''); li.appendChild(name);
        li.appendChild(el('span', 'clv-price', row.gift ? 'Included' : (state.itemMoney || state.money)(row.cents)));
        if (row.remove) {
          var remove = el('button', 'clv-remove', '×'); remove.type = 'button';
          remove.setAttribute('aria-label', 'Remove ' + row.title); remove.addEventListener('click', row.remove); li.appendChild(remove);
        }
      }
      list.appendChild(li);
    });
  }
  global.ClutchLoopCheckoutView = { prepare: prepare, render: render, entries: entries };
})(typeof window !== 'undefined' ? window : globalThis);
